import script from "./BaseDefineStore.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDefineStore.vue?vue&type=script&setup=true&lang=js"

import "./BaseDefineStore.vue?vue&type=style&index=0&id=67ede3ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ede3ec"]])

export default __exports__